export const windowDisplaysQueryKeys = {
  _base: () => ["windowDisplays"],
  all: (agencyId: string) => [...windowDisplaysQueryKeys._base(), { agencyId }],
};

export const windowDisplayAdsQueryKeys = {
  _base: () => ["windowDisplayAds"],
  all: (windowDisplayId: string) => [...windowDisplayAdsQueryKeys._base(), { windowDisplayId }],
};

